import React from "react";
import {Route} from "react-router-dom";
import Split from "../../pages/corporateAction/split";
import Exchange from "../../pages/corporateAction/exchange";
import Payment from "../../pages/corporateAction/payment";
import Detail from "../../pages/corporateAction/detail";
import {
    DETAIL_CORPORATE_ACTION_ROUTE,
    EXCHANGE_ROUTE,
    PAYMENT_ROUTE,
    SPLIT_ROUTE
} from "../../utils/constants/RoutesConstants";

const CorporateActionRoutes = () => {
    return (
        <React.Fragment>
            <Route path={SPLIT_ROUTE} component={Split}/>
            <Route path={EXCHANGE_ROUTE} component={Exchange}/>
            <Route path={PAYMENT_ROUTE} component={Payment}/>
            <Route path={DETAIL_CORPORATE_ACTION_ROUTE} component={Detail}/>
        </React.Fragment>
    );
};

export default CorporateActionRoutes;